import axios from "axios";
import { getDomainSite, removeDomainSite } from "./site";
import { log2 } from "./log2";
import { CONFIG } from "./config";
import { getTempData } from "./persistenceStorage";

removeDomainSite();
const log = log2("request.js");
// let apiAddress =
//     !CONFIG.isProd && CONFIG.isMobile ? "http://mobile-tablet-local.supsis.live/api/" : process.env.TABLET_URL;
let apiAddress = process.env.TABLET_URL;

// create an axios instance
const service = axios.create({
    baseURL: apiAddress,
    timeout: 20000, // request timeout
});

// request interceptor
service.interceptors.request.use(
    (config) => {
        log("getDomainSite", getDomainSite());
        if (getDomainSite()) {
            var site = JSON.parse(getDomainSite());
            log("site", site);
            config.headers["site-id"] = site._id;
        }
        const sessionId = getTempData("sessionId");
        if(sessionId) config.headers["session-id"] = sessionId;
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js